import cx from 'classnames';

import Breadcrumbs from '../breadcrumbs';
import ContentContainer from '../content-container';
import Divider from '../divider';
import { Heading, Subheading } from '../typography';
import { Text } from 'components/@tedui';

type PageHeaderProps = {
  titleHeading?: string;
  title: string;
  subtitle?: string;
  breadcrumbsLinks?: { label: string; link?: string }[];
  leftAligned?: boolean;
  subtitleLink?: string | null;
  subTitleLinkText?: string | null;
  hasPaddingVertical?: boolean;
  UNSAFE_className?: string;
};

export default function PageHeader({
  titleHeading,
  title,
  subtitle,
  breadcrumbsLinks,
  leftAligned,
  subtitleLink,
  subTitleLinkText,
  hasPaddingVertical = true,
  UNSAFE_className = ''
}: PageHeaderProps): React.ReactNode {
  const hasUnsafeClassName = UNSAFE_className && UNSAFE_className.length;
  const hasTitleHeading = titleHeading && titleHeading.length;
  const hasBreadcrumbs = breadcrumbsLinks && breadcrumbsLinks.length;
  const isCentered = !leftAligned && !hasBreadcrumbs;
  const headerClasses = cx('text-black', {
    'pb-10 pt-11 text-center md:px-16 md:py-12 xl:px-28':
      isCentered && !UNSAFE_className,
    'pb-8 pt-5 md:pb-12 md:pt-10': !isCentered && !UNSAFE_className,
    'xl:py-20': hasPaddingVertical,
    [UNSAFE_className]: hasUnsafeClassName
  });

  const subtitleClasses = cx('text-gray-500 md:mt-4 lg:w-2/3', {
    'mx-auto mt-4 xl:mt-6': isCentered,
    'mt-3 xl:mt-4': !isCentered
  });
  return (
    <ContentContainer>
      <header className={headerClasses}>
        {hasBreadcrumbs && (
          <Breadcrumbs
            links={breadcrumbsLinks}
            className="mb-4 md:mb-3 xl:mb-8"
          />
        )}
        {hasTitleHeading && (
          <Text
            variant="caption1"
            tag="p"
            weight="font-semibold"
            color={{ override: '#555555' }}
            UNSAFE_className="mb-3 uppercase"
          >
            {titleHeading}
          </Text>
        )}
        <Heading size={isCentered ? '3xl' : '2xl'} tagName="h1">
          {title}
        </Heading>
        {subtitle && (
          <Subheading
            tagName="p"
            className={subtitleClasses}
            {...{ role: 'doc-subtitle' }}
          >
            {subtitle}{' '}
            {subtitleLink && subTitleLinkText && (
              <a className="font-bold hover:underline" href={subtitleLink}>
                {subTitleLinkText}
              </a>
            )}
          </Subheading>
        )}
      </header>
      <Divider isLarge />
    </ContentContainer>
  );
}
